<template>
  <div class="index-page container">
  
    <n-card :loading="$var('loadImage')" style="max-width: 1000px;">
      <h3 slot="header">Файл Расписание курсов</h3>
      <a :href="file.image" target="_blank">Скачать</a>
  
      <n-form @submit="saveFile">
        <n-items>
          <n-upload title="Загрузить новый файл" :value.sync="newFile" />
          <br />
          <n-button color="primary" type="submit">Загрузить</n-button>
        </n-items>
      </n-form>
    </n-card>
    
    <n-card>
      <h3>Редактирование контента</h3>
      <n-list :data="data">
        <template #item="{ item, }">
          <div>
            <div class="item">
              <div class="title">
                <n-icon icon="pen" @click.stop="() => $var('edit', item)" />
                <div class="code">[{{ item.field }}]</div>
                <div class="text" v-html="item.value" />
              </div>
            </div>
          </div>
        </template>
        <template #tools="{ item, }">
          <span></span>
        </template>
      </n-list>
  
      <modal-edit v-if="$var('edit')" :model="$var('edit')" :update="load" @close="$var('edit', false)" />
    </n-card>
  </div>
</template>

<script>
import ModalEdit from './ModalEdit'

export default {
  name: 'Index',
  components: { ModalEdit, },
  data: () => ({
    data: [],
    file: {},
    newFile: null,
  }),
  mounted() {
    this.load()
    this.loadFile()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.translations.getByTag('content').then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadFile() {
      this.$var('loadImage', true)
      $api.app.images.getFiles().then((response) => {
        this.file = response.data.content[0]
      }).finally(() => {
        this.$var('loadImage', false)
      })
    },
    saveFile() {
      this.$var('loadImage', true)
      $api.files.create({ file: this.newFile, }).then((file) => {
        $api.app.images.edit(this.file.id, { image: file.data.content.id, }).then((result) => {
          this.newFile = null
          this.file = result.data.content
        }).finally(() => {
          this.$var('loadImage', false)
        })
      }).catch(() => {
        this.$var('loadImage', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
    --n-image-width: 180px;
    --n-image-height: 200px;
    --n-modal-width: 700px;
    .item {
      .title {
        display: flex;
        .code {
          font-size: .9em;
          opacity: .8;
          margin-right: 10px;
        }
        .n-icon {
          font-size: .9em;
          cursor: pointer;
          margin-right: 15px;
        }
      }
    }
  }
</style>
